import { Code, ConnectError } from '@bufbuild/connect';

// Server message when a student submits before finishing the assigned
// resources. The handler's generic catch reports it as Internal, so match the text.
export const RESOURCES_INCOMPLETE_MESSAGE =
  'Complete all assigned resources before submitting.';

export const getLearningHwErrorMessage = (err: unknown, fallback: string) => {
  if (!navigator.onLine) {
    return 'You are offline. Please reconnect and try again.';
  }
  const connectError = ConnectError.from(err);
  if (connectError.rawMessage.includes(RESOURCES_INCOMPLETE_MESSAGE)) {
    return RESOURCES_INCOMPLETE_MESSAGE;
  }
  if (connectError.rawMessage.includes('deadline')) {
    return 'The deadline for this homework has passed.';
  }
  switch (connectError.code) {
    case Code.InvalidArgument:
      return 'Some details are invalid. Please check and try again.';
    case Code.PermissionDenied:
      return 'You do not have access to this homework.';
    case Code.NotFound:
      return 'This homework no longer exists.';
    case Code.FailedPrecondition:
      return 'This action is not possible right now.';
    case Code.DeadlineExceeded:
      return 'The request timed out. Please try again.';
    default:
      return fallback;
  }
};
